import React from 'react';

export const Visa = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7846_182903)">
      <path
        d="M40.7344 31.4281C40.7344 32.7341 39.6758 33.7927 38.3699 33.7927H3.09883C1.79297 33.7928 0.734375 32.7341 0.734375 31.4281V8.57156C0.734375 7.26563 1.79297 6.20703 3.09883 6.20703H38.3699C39.6759 6.20703 40.7344 7.2657 40.7344 8.57156V31.4281Z"
        fill="white"
      />
      <path
        d="M9.61234 20.1604L8.67312 15.6548C8.51258 15.0335 8.04539 14.8487 7.46164 14.8242H3.15555L3.11719 15.0301C6.47102 15.8431 8.69016 17.8045 9.61234 20.1604Z"
        fill="#F79F1A"
      />
      <path
        d="M19.5902 14.9134H16.8079L15.0702 25.1108H17.8479L19.5902 14.9134ZM11.3082 25.1005L15.684 14.9203H12.7394L10.0173 21.8756L9.72672 20.8255C9.19312 19.5621 7.66812 17.7438 5.87781 16.5991L8.36609 25.104L11.3082 25.1005ZM27.5259 21.7773C27.5362 20.6195 26.7928 19.7365 25.1909 19.0071C24.2174 18.536 23.6241 18.2219 23.6312 17.7438C23.6312 17.3215 24.1337 16.8678 25.2224 16.8678C26.1334 16.8538 26.7894 17.0527 27.3024 17.2587L27.5538 17.3739L27.9309 15.1648C27.3794 14.9588 26.5173 14.7389 25.4391 14.7389C22.6924 14.7389 20.7591 16.121 20.7416 18.1033C20.7241 19.5691 22.1238 20.3858 23.1776 20.8743C24.2594 21.3723 24.6223 21.6909 24.6154 22.1377C24.6084 22.8207 23.7533 23.1322 22.9541 23.1322C21.8409 23.1322 21.251 22.9787 20.3363 22.5976L19.9808 22.4343L19.5903 24.7194C20.239 25.0029 21.4394 25.2507 22.6855 25.261C25.6063 25.261 27.5049 23.8965 27.5259 21.7773ZM30.8307 23.5823C31.1483 23.5823 33.9855 23.5859 34.3905 23.5859C34.4743 23.9409 34.7291 25.1144 34.7291 25.1144H37.308L35.057 14.9239H32.9108C32.2441 14.9239 31.7488 15.1054 31.4555 15.7684L27.327 25.1144H30.2482C30.248 25.1144 30.7225 23.8582 30.8307 23.5823ZM32.7361 18.6441C32.7223 18.672 32.9666 18.0543 33.1062 17.6704L33.2945 18.5498C33.2945 18.5498 33.8252 20.9859 33.9367 21.4954H31.6298C31.8602 20.9091 32.7361 18.6441 32.7361 18.6441ZM38.3699 6.20703H3.09883C1.79297 6.20703 0.734375 7.26563 0.734375 8.57156V11.0256H40.7344V8.57156C40.7344 7.26563 39.6759 6.20703 38.3699 6.20703Z"
        fill="#059BBF"
      />
      <path
        d="M38.3699 33.7913H3.09883C1.79297 33.7913 0.734375 32.7326 0.734375 31.4267V28.9727H40.7344V31.4267C40.7344 32.7326 39.6759 33.7913 38.3699 33.7913Z"
        fill="#F79F1A"
      />
      <path
        opacity="0.15"
        d="M2.41539 31.4281V8.57156C2.41539 7.26563 3.47406 6.20703 4.78 6.20703H3.09875C1.79297 6.20703 0.734375 7.26563 0.734375 8.57156V31.4282C0.734375 32.7341 1.79297 33.7928 3.09883 33.7928H4.78008C3.47414 33.7928 2.41539 32.7341 2.41539 31.4281Z"
        fill="#202121"
      />
    </g>
    <defs>
      <clipPath id="clip0_7846_182903">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.734375)"
        />
      </clipPath>
    </defs>
  </svg>
);
